export const friendInviteNotification = {
    type: 'friend-invite',
    name: 'Friend Invite',
    description: 'Sent when someone invites you to be friends on Rout.',
    emailRequired: true,
    defaultEnabled: true,
    text(data, context) {
        return `${data.inviterName} sent you a friend invite.${context === 'push' ? ' Tap to respond!' : ''}`;
    },
    title() {
        return `New friend invite!`;
    },
    link(_data) {
        return '/friends';
    },
};
//# sourceMappingURL=friendInvite.js.map